var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-list"},_vm._l((_vm.createdBlocks),function(block,index){return _c('blocks-commons',{key:block.id || index,attrs:{"index":index + _vm.indexOffset}},[_c(block.componentName,{tag:"component",attrs:{"block":block}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }